import $ from 'jquery'

const $doc = $(document)

function eventFuncs() {
  const $sliders = $('.js-featured-slider:not(.slick-initialized)')
  if ($sliders.length) {
    $sliders.each(function () {
      let $el = $(this);
      $el.on('init', function(event, slick) {
        slick.$slides.each(function(index) {
          $(this).attr({
            'role': 'group',
            'aria-roledescription': 'slide',
            'aria-label': 'Slide ' + (index + 1) + ' of ' + slick.slideCount
          });
        });
      });
      $el.slick({
        arrows: true,
        dots: true,
        speed: 600,
        prevArrow: '<button type="button" class="slick-prev"><span class="u-sr-only">Previous</span><svg focusable="false" aria-hidden="true" width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 11L26 11" stroke="black"/><path d="M11 21L1.5 11L11 1" stroke="black"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="u-sr-only">Next</span><svg focusable="false" aria-hidden="true" width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 11L8.9407e-07 11" stroke="black"/><path d="M15 21L24.5 11L15 1" stroke="black"/></svg></button>'
      });
    });
  }
  $doc.on('click', '.js-open-filters', function () {
    let el = $(this)
    el.attr('aria-expanded', 'true')
    $('#event-filters').addClass('active')
  });
  $doc.on('click', '.js-close-filters', function () {
    let el = $(this)
    el.attr('aria-expanded', 'false')
    $('#event-filters').removeClass('active')
  });
  $doc.on('click', '.js-filter-accordion', function(){
    let el = $(this);
    el.toggleClass('active');
    el.parent().parent().parent().find('.blog__checklist').slideToggle();
    if ( el.hasClass('active') ) {

    } else {

    }
  });
}
function ajaxLoadPosts(page = 1, loc = '', past = '', feat = '' ) {
  const data = {
    page: page,
    loc: loc,
    past: past,
    feat: feat,
    action: 'ajax_event_filter'
  };

  $.ajax({
    url: php_vars.ajax_url,
    type: "POST",
    dataType: 'html',
    data,
    beforeSend: function () {
      $('body').find('#events-wrap').html('<div class="loader"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox = "0 0 100 100" enable - background="new 0 0 0 0" xml: space = "preserve" ><rect x="38" y="35" width="4" height="10" fill="#76DCB6"><animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0" dur="0.6s" repeatCount="indefinite" /></rect><rect x="48" y="35" width="4" height="10" fill="#76DCB6"><animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.2s" dur="0.6s" repeatCount="indefinite" /></rect><rect x="58" y="35" width="4" height="10" fill="#76DCB6"><animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.4s" dur="0.6s" repeatCount="indefinite" /></rect></svg ></div>');
    },
    success: function (htmlResponse) {
      if (htmlResponse == "" || htmlResponse == null) {
        $('body').find('#events-wrap').html('<p class="no-results">No results found, please try a different combination of filters.</p>');
      }
      else {
        $('body').find('#events-wrap').html(htmlResponse);
      }
    },
    error: function () {
      $('body').find('#events-wrap').html('<p class="no-results">Sorry, no results found.</p>');
    },
    complete: function () {
      //$('body').find('#posts-wrap').css('opacity', 1);
    }
  });
}

function filterPosts() {
  let page = 2;
  let loc;
  let past;
  let feat;
  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('loc')) {
      loc = searchParams.get('loc');
      $('#'+loc).prop('checked', true);
    }
    if (searchParams.has('loc')) {
      ajaxLoadPosts(1, loc, past, feat);
    }
  }
  if ($('body').hasClass('page-template-past-events')) {
    past = true;
  }
  if ($('.js-feat-event').is('[data-featured-id]')) {
    feat = $('.js-feat-event').attr('data-featured-id');
  }
  $('.js-post-filter').on('change', function (event) {
    $("#location-filter input:checkbox").not($(this)).prop('checked', false);
    loc = $("#location-filter input:checkbox:checked").val();
    if ( !loc ) {
      $('#location-filter').find('.js-filter-count').text('').addClass('hidden')
    } else {
      $('#location-filter').find('.js-filter-count').text('1').removeClass('hidden')
    }
    ajaxLoadPosts(1, loc, past, feat);
  });

  $doc.on('click', '.js-posts-pagination button', function () {
    page = $(this).data('page');
    ajaxLoadPosts(page, loc, past, feat);
  });
  $doc.on('click', '.js-filter-clear', function () {
    $('.js-post-filter').prop('checked', false);
    $('.js-filter-count').text('').addClass('hidden');
    ajaxLoadPosts(1, '', past, feat);
  });
}

export default function initEventFunctions(){
  if ($('body').hasClass('page-template-events') || $('body').hasClass('page-template-past-events')) {
    eventFuncs();
    $(document).ready(filterPosts);
  }
}
